import { ModalType, LModalContentsWidthType } from '@lib/components';
import { ModalBlockParts } from '@lib/services';
import { FareRulesDetailComponent } from './fare-rules-detail.component';
import { FareConditionsResponseData, GetOrderResponseData } from 'src/sdk-servicing';

export function FareRulesDetailPayloadParts(): ModalBlockParts {
  return {
    id: 'FareRulesDetailComponent',
    block: FareRulesDetailComponent,
    closeBackEnable: true,
    type: ModalType.TYPE2,
    modalWidth: LModalContentsWidthType.MODAL_PC_W1000,
    payload: {} as {
      fareConditions: FareConditionsResponseData;
      orderData: GetOrderResponseData;
    },
  };
}
